/*
 * @Author: 赵泽文
 * @Date: 2022-03-07 16:36:38
 * @LastEditors: 赵泽文
 * @LastEditTime: 2023-12-29 15:47:20
 * @Description: 退货单数据存储
 */

import type {
  IEarthInnerApplyOrderModel,
  IEarthInnerApplyOrderStore,
} from '@monorepo/types/earthOrders/innerApplyOrder/innerApplyOrder.types';

import { getToday } from '@monorepo/utils';
import { tableUpdate } from '@monorepo/utils';
// import moment from 'moment';

const initState: IEarthInnerApplyOrderStore = {
  isInit: true,
  tableList: [],
  total: 0,
  query: {
    pageSize: 50,
    page: 1,
    date_from: '',
    date_to: '',
    date: getToday(),
    date_type: '制单时间',
  },
  auditNo: '',
  // auditProductList: [],
};

const earthInnerApplyOrderStore: IEarthInnerApplyOrderModel = {
  namespace: 'earthInnerApplyOrderStore',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
    updateTableList(state, { payload }) {
      const tableList = tableUpdate(state.tableList, payload.data, payload.auditNo);
      return {
        ...state,
        tableList,
      };
    },
    resetInit() {
      return { ...initState };
    },
  },
};

export default earthInnerApplyOrderStore;
